import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import home1 from '../img/home1.png';
import home2 from '../img/home2.png';
import home3 from '../img/home3.png';
import fueling1 from '../img/fueling-1.png';
import logoDK from '../img/logo-dk.png';
import Footer from './Footer';
import Banner from './Banner';

class Home extends Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }
    omponentDidMount() {
        window.scrollTo(0, 0);
    }

    handleClick(event) {
        event.preventDefault();
        let path = '';
        switch (event.target.id) {

            case 'homeBtn':
                path = '/';
                this.props.history.replace(path);
                break;
            case 'aboutBtn':
                path = '/about';
                this.props.history.replace(path);
                break;
            case 'valuedcustomersBtn':
                path = '/valued-customers';
                this.props.history.replace(path);
                break;
            case 'customAppsBtn':
                path = '/custom-applications';
                this.props.history.replace(path);
                break;
            case 'techSuppBtn':
                path = '/technology-support';
                this.props.history.replace(path);
                break;
            case 'BusContBtn':
                path = '/business-continuity';
                this.props.history.replace(path);
                break;
            case 'techTalkBtn':
                path = 'tech-talk';
                this.props.history.replace(path);
                break;
            case 'contactBtn':
                path = '/contact-us';
                this.props.history.replace(path);
                break;
            case 'networkAuditBtn':
                path = '/it-support-network-audit';
                this.props.history.replace(path);
                break;
            default:
                break;
        }
    }

    render() {
        return (
            <div>
                <Banner
                    headText="BUSINESS SOLUTIONS THROUGH TECHNOLOGY"
                    subHeadText="We create personalized technology solutions for
                                small and medium sized companies that help protect
                                your business and scale as it grows."
                    subBoldText="INNOVATIVE. AFFORDABLE. PRACTICAL."
                    img="hero-1.jpg"
                />

                <div className="row2Home container">

                    <div className="row">

                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12 animated slideInLeft">
                            <img src={home1} alt="" className="img-responsive rcenter" />
                            <h1>Custom Applications</h1>
                            <p>
                                We deliver expertly crafted business applications customized to meet your specific needs. 
                                Discover the many benefits a custom mobile app, CRM, and more can have on your business productivity. 
                                Surprisingly affordable. Amazingly functional.
                                <br />
                                <br />
                                <br />
                                <a id="customAppsBtn" onClick={this.handleClick} className="btn btn-default">Learn More</a>
                            </p>
                        </div>


                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12 animated fadeIn">
                            <img src={home2} alt="" className="img-responsive rcenter" />
                            <h1>Technology Support</h1>
                            <p>
                                We provide cost effective support options to keep your business technologies humming 24/7.  
                                Learn how our programs will keep you focused on what counts: being competitive and profitable.  
                                Surprisingly affordable. Reliably efficient.
                                <br />
                                <br />
                                <br />
                                <a id="techSuppBtn" onClick={this.handleClick} className="btn btn-default">Learn More</a>
                            </p>
                        </div>


                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12 animated slideInRight">
                            <img src={home3} alt="" className="img-responsive rcenter" />
                            <h1>Business Continuity</h1>
                            <p>
                                We are your bridge over troubled waters. Natural or man-made, calamities don't have to bring your business down. 
                                Our customized continuity programs will help your business survive the unsurvivable.  
                                Surprisingly affordable. Dependably reliable.
                                <br />
                                <br />
                                <a id="BusContBtn" onClick={this.handleClick} className="btn btn-default">Learn More</a>
                            </p>
                        </div>
                    </div>



                </div>






                <div className="main-container row3Home">
                    <div className="container">
                        <div className="row">


                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <h1><strong>TECH TALK<br />
                                    <span className="techpush">Business Continuity: <br />
                                        How It Can Save Your Business From Disaster</span></strong><br />
                                    <br />
                                    <a href="/tech-talk" className="btn btn-large btn-warning" style={{ color: '#003366' }}>READ IT NOW <span className="glyphicon glyphicon-play"></span></a></h1>
                            </div>



                        </div>
                    </div>
                </div>






                <div className="main-container row4Home">
                    <div className="container">
                        <div className="row">

                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">


                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <img src={fueling1} className="img-responsive rcenter img-circle" alt="" /> </div>
                                <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                    <h2>Fueling The Success Of Our Customers</h2>
                                    At Automated Concepts, we believe that our success is defined by building long-term relationships with our clients and helping their businesses grow. We succeed when our clients succeed and we work every day to help make that happen. We take the time to get to know our clients and understand their individual business requirements to partner for the long haul...<br /><br />
                                    <a href="/fueling-success" className="btn btn-default">Learn More</a>
                                </div>

                            </div>


                        </div>
                    </div>
                </div>


                
            </div>
        );
    }
}

export default withRouter(Home);


// WEBPACK FOOTER //
// ./src/components/Home.js